import { Component, OnInit } from '@angular/core';
import { HcaUserManagementService } from '../../../../../../shared/_services/hca-user-management.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HotelManagementService } from '../../../../../../shared/_services/hotel-management.service';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { BsModalService } from 'ngx-bootstrap';
import { StatusModalComponent } from '../../../../../modals/status-modal/status-modal.component';
import { environment } from '../../../../../../../environments/environment';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-hotels-list',
  templateUrl: './hotels-list.component.html',
  styleUrls: ['./hotels-list.component.scss']
})
export class HotelsListComponent implements OnInit {
  hotelChainName: string = localStorage.getItem('loggedInUser') ? JSON.parse(localStorage.getItem('loggedInUser')).hotelChainName : null;
  hotelBrands: any[] = [];
  hotels: any[] = [];
  hotels_inactive: any[] = [];
  hotels_active: any[] = [];
  selectedBrand: any;
  environment = environment;
  imageUrl = 'assets/images/sandos-logo-192.png';
  statusModal: BsModalRef;
  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(private fb: FormBuilder,
    public hcaUserManagementService: HcaUserManagementService,
    private hotelManagementService: HotelManagementService,
    private modalService: BsModalService) {

    this.modalService.onHide
      .takeUntil(this.unsubscribe).subscribe(res => {
        if (this.statusModal) {
          if (this.statusModal.content.srcObject.action == "action1") {
            if (this.statusModal.content.srcObject.type == "hotel-list") {

              this.hotelManagementService.activateOrDeactivateHotel(this.statusModal.content.srcObject.id, this.statusModal.content.srcObject.status).subscribe(
                res => {
                  if (this.selectedBrand) {
                    this.getHotelsByBrand(this.selectedBrand);
                  }
                }, error => {
                  console.error(error);
                });
            }
          }
        }
      });
  }

  ngOnInit() {
    this.getHotelBrandsByHotelChain();
  }

  getHotelBrandsByHotelChain() {
    this.hcaUserManagementService.getHotelBrandsByHotelChain().subscribe(
      res => {
        if (res.error == 0) {
          this.hotelBrands = res.responseObj;
          if (res.responseObj.length > 0) {
            let brandSelected = this.hotelManagementService.getSelectedBrand();
            this.selectedBrand = brandSelected ? brandSelected : res.responseObj[0];
            this.getHotelsByBrand(this.selectedBrand);
          }
        }
        else {
          console.error("Get Hotel Brands : " + res.message);
        }
      }, err => {
        console.error(err);
      });
  }
  getHotelsByBrand(brand) {
    this.hotels = [];
    this.selectedBrand = brand;
    this.hotelManagementService.setSelectedBrand(brand);
    this.hcaUserManagementService.getHotelsByBrand([brand.brandId]).subscribe(
      res => {
        if (res.error == 0) {
          this.hotels = res.responseObj ? res.responseObj : [];
          if (this.hotels.length) {
            this.hotels_inactive = this.hotels.filter(hotel => hotel.status === "Inactive");
            this.hotels_active = this.hotels.filter(hotel => hotel.status === "Active");
          }
        }
        else {
          this.hotels = [];
          console.error("Get Hotels : " + res.message);
        }
      }, err => {
        console.error(err);
      });
  }

  openModalActivateDeactivate(id, mode) {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    let message = "";
    let title = "";
    let action1 = "";
    let style = "";
    let status = "";
    if (mode == 'Active') {
      message = "Are you sure you want to deactivate this hotel?";
      title = "Deactivate Hotel";
      action1 = "Deactivate";
      style = "inactive";
      status = "Inactive";
    }
    else if (mode == 'Inactive') {
      message = "Are you sure you want to activate this hotel?";
      title = "Activate Hotel";
      action1 = "Activate";
      style = "active";
      status = "Activate";
    }
    this.statusModal.content.srcObject = {
      mode: "custom",
      type: 'hotel-list',
      title: title,
      message: message,
      status: status,
      id: id,
      action1: action1,
      action2: 'Cancel',
      action: '',
      style: style
    }
  }


  goToAddHotels() {
    console.log(this.hotelBrands.length);
  }

  getStyle(hotel) {
    return `url('${environment.BASE_IMAGE_API}/images/hotels/${hotel.hotelId}/${hotel.banner}')`;
  }

  ngOnDestroy() {
    this.hotelManagementService.clearSelectedBrand();
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/hotels/hotel-management/hotels-list/hotels-list.component.ts